<div
  class="banner"
  role="banner"
  *ifScreenSize="screenSize.Desktop"
  [style.background-image]="
    'url(' + ('banners/banner.jpg' | contentAssetImage) + ')'
  "
>
  <div class="container d-flex align-items-center justify-content-between">
    <ng-container *ngIf="isHomePage; else defaultTitle">
      <div *ngIf="memberDetails$ | async as member">
        <a class="banner-welcome-link" [routerLink]="['/account']">
          <span class="banner-welcome"
            >{{ "home.banner.welcome" | translate }}
            {{ member.FirstName }}</span
          >
          <span class="material-icons banner-chevron">chevron_right</span>
        </a>
        <p class="banner-subtitle" *ngIf="memberCard$ | async as card">
          {{ "home.banner.valued.member" | translate }}
          {{ card.ExternalRefNumber }}
        </p>
      </div>
    </ng-container>
    <ng-template #defaultTitle>
      <h1 class="banner-title">{{ pageName | translate }}</h1>
    </ng-template>
    <img
      class="banner-logo"
      [src]="'logos/phxid-logo.svg' | contentAssetImage"
      alt="PHX ID logo"
      draggable="false"
    />
  </div>
</div>
